export const routeAndSectionMixin = {
  data() {
    return {
      route: '',
      section: ''
    }
  },
  mounted() {
    const matched = this.$route.matched.slice(-1)[0]
    if (!matched) {
      return
    }

    if (matched.parent) {
      this.route = matched.parent.path
      this.section = matched.path.replace(this.route, '')
    } else {
      this.route = matched.path
    }

    if (typeof params === 'object' && params !== null) {
      for (const param in params) {
        this.route = this.route.replace(
          new RegExp(`:${param}`, 'i'),
          params[param]
        )
      }
    }
  }
}
